import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { find } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { changeRequestsSelectors } from '../../../../state/ducks/changeRequest';
import { OptionType } from '../../../components/forms/fields/Autocomplete/types';
import { Mode, MODE_FIELD } from '../../../components/KendoDataGrid/constants';
import OverflowTooltip from '../../../components/OverflowTooltip';
import { CustomTemplateProps, EditableReference } from '../types';

export const OwnerCell: React.FC<CustomTemplateProps> = ({
  dataItem,
  field,
  onClick,
}) => {
  const formik = useFormikContext<EditableReference>();
  const availableUsers = useSelector(changeRequestsSelectors.getUsersList);
  const fieldValue = [Mode.add, Mode.edit].includes(dataItem[MODE_FIELD])
    ? formik?.values[field] || dataItem[field]
    : dataItem[field];
  const getUserDetails = (userId: string): OptionType | undefined =>
    find(availableUsers, { value: userId });
  const user = getUserDetails(fieldValue ?? '');

  return (
    <Box onClick={() => onClick?.({ dataItem })} data-cy={`${field}-value`}>
      <OverflowTooltip title={user?.label} placement="top" arrow>
        {user?.label}
      </OverflowTooltip>
    </Box>
  );
};
